import appConstants from '../../../../../../../appConstants';
import { MultiSelectFilter, DateTimeFilter } from '@dataGrid/components/columnFilters';
import { formatDateTime } from '@dataGrid/gridUtilities';
import { formatPhone } from '../../../../../Dispatch/utils/utils';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration(config);
  }

  static lastModifiedDateValueGetter = (params) => {
    return formatDateTime({ value: params.data.lastModifiedDateTs });
  };

  static formatReceiverContact = (params) => {
    return formatPhone(params.value);
  };

  static getDefaultConfiguration() {
    return {
      keyColumn: 'receiverId',
      rowSelection: 'single',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: MultiSelectFilter
      },
      columns: [
        {
          headerName: 'receiverId',
          field: 'receiverId',
          hide: true,
          headerTooltip: 'receiver Id'
        },
        {
          headerName: 'Receiver Name',
          headerTooltip: 'Receiver Name',
          field: 'receiverName',
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_150
        },
        {
          headerName: 'Contact',
          headerTooltip: 'Contact',
          field: 'receiverContact',
          valueFormatter: GridConfig.formatReceiverContact,
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120
        },
        {
          headerName: 'Email',
          headerTooltip: 'Email',
          field: 'receiverEmail',
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120
        },
        {
          headerName: 'Last Modified',
          headerTooltip: 'Last Modified',
          field: 'lastModifiedDateTs',
          filter: DateTimeFilter,
          valueGetter: GridConfig.lastModifiedDateValueGetter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATETIME,
            useGetterValue: true
          },
          minWidth: appConstants.columnWidth.W_140
        }
      ]
    };
  }
}
